export const getHoursAmPm = (hours) => {
    if (hours < 10 && hours >= 0) {
        return '0' + hours;
    }
    var amPmHours = hours <= 12 ? hours : hours - 12;
    return amPmHours < 10 ? '0' + amPmHours : amPmHours;
};

// DEFAULT METHOD TO DISPLAY DATE
export const getTimeShortWithMinutes = (date) => {
    if (!date) return '';

    const dateObject = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObject.getTime())) {
        return '';
    }

    const days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

    const dayNumber = dateObject.getDay();
    const dayName = days[dayNumber];
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();
    const hours = dateObject.getHours(); // Horas en formato 24h
    const minutes = dateObject.getMinutes();

    return `${dayName} ${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month} ${
        hours < 10 ? '0' + hours : hours
    }:${minutes < 10 ? '0' + minutes : minutes}`;
};

export const getTimeShortWithMinutesLong = (date) => {
    if (!date) return '';

    const dateObject = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObject.getTime())) {
        return '';
    }

    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    const dayNumber = dateObject.getDay();
    const dayName = days[dayNumber];
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();
    const hours = dateObject.getHours(); // Horas en formato 24h
    const minutes = dateObject.getMinutes();

    return `${dayName} ${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month} ${
        hours < 10 ? '0' + hours : hours
    }:${minutes < 10 ? '0' + minutes : minutes}`;
};

export const getTimeShortWithMinutesLongWithYear = (date) => {
    if (!date) return '';

    const dateObject = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObject.getTime())) {
        return '';
    }

    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    const year = dateObject.getFullYear();
    const dayNumber = dateObject.getDay();
    const dayName = days[dayNumber];
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();
    const hours = dateObject.getHours(); // Horas en formato 24h
    const minutes = dateObject.getMinutes();

    return `${dayName} ${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year} ${
        hours < 10 ? '0' + hours : hours
    }:${minutes < 10 ? '0' + minutes : minutes}`;
};

export const getTimeShortWithYear = (date) => {
    if (!date) return '';

    const dateObject = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObject.getTime())) {
        return '';
    }

    let days = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];

    const dayNumber = dateObject.getDay();
    const dayName = days[dayNumber];
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();

    return `${dayName} ${day < 10 ? '0' + day : day}/${
        month < 10 ? '0' + month : month
    }/${year} ${getHoursAmPm(hours)}:${minutes < 10 ? '0' + minutes : minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
};

export const getDate_dd_MM = (date) => {
    if (!date) return '';

    const d = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(d.getTime())) {
        return '';
    }

    const month = d.getMonth() + 1;
    const day = d.getDate();
    return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}`;
};

export const getDateMMddHHmm = (dateCSharpFormat) => {
    // Verificar si el formato de la fecha es válido antes de intentar convertirla
    if (!dateCSharpFormat) {
        return 'Fecha inválida'; // Valor predeterminado para fechas inválidas o nulas
    }

    const parsedDate = Date.parse(dateCSharpFormat);

    // Si la fecha no puede ser parseada, retornar una cadena predeterminada
    if (isNaN(parsedDate)) {
        return 'Fecha inválida'; // Valor predeterminado para fechas no válidas
    }

    const date = new Date(parsedDate);

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);

    return `${day}/${month} ${hours}:${minutes}`;
};

export const getDateMMddYYYYHHmm = (dateCSharpFormat) => {
    const date = new Date(Date.parse(dateCSharpFormat));

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);

    return `${day}/${month}/${date.getFullYear()} ${hours}:${minutes}`;
};

export const getDateYYYYMMdd = (dateCSharpFormat) => {
    const date = new Date(Date.parse(dateCSharpFormat));

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${date.getFullYear()}/${month}/${day}`;
};

export const convertUTCDateToLocalDate = (utcDate) => {
    if (!utcDate) return '';

    const localDate = new Date(utcDate);

    // Validar que la fecha sea válida
    if (isNaN(localDate.getTime())) {
        return '';
    }

    const options = {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    };

    // 'es' locale is used for Spanish
    return new Intl.DateTimeFormat('es', options).format(localDate);
};

export const convertUTCDateToLocalDateShort = (utcDate) => {
    if (!utcDate) return '';

    const localDate = new Date(utcDate);

    // Validar que la fecha sea válida
    if (isNaN(localDate.getTime())) {
        return '';
    }

    const day = String(localDate.getDate()).padStart(2, '0');
    const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
    const year = localDate.getFullYear().toString().slice(-2);
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const convertToShortDate = (date, divider) => {
    if (!date) return '';

    // Crear un objeto Date a partir de la fecha original
    const dateObj = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObj.getTime())) {
        return '';
    }

    // Obtener el mes y el día del objeto Date
    const mes = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Sumamos 1 porque los meses en JavaScript son base 0
    const dia = dateObj.getDate().toString().padStart(2, '0');

    // Crear la cadena en el formato deseado "10-12"
    const fechaFormateada = `${mes}${divider ?? '-'}${dia}`;

    return fechaFormateada;
};

export const getStartAndEndDatesForMonthUTC = (currentDateSelected) => {
    const currentDate = new Date(currentDateSelected);
    const currentYear = currentDate.getUTCFullYear();
    const monthNumber = currentDate.getUTCMonth() + 1; // getUTCMonth() devuelve un rango de 0-11

    // Calcular startDate para el mes dado en UTC
    const startDate = new Date(Date.UTC(currentYear, monthNumber - 1, 1));

    // Calcular endDate para el mes siguiente en UTC
    const nextMonth = (monthNumber % 12) + 1;
    const endYear = nextMonth === 1 ? currentYear + 1 : currentYear;
    const endDate = new Date(Date.UTC(endYear, nextMonth - 1, 1));

    return {
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
    };
};

export const formatDateToDDMMYYAsString = (fechaISO8601) => {
    const meses = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
    ];

    const partes = fechaISO8601.split('T')[0].split('-');
    const año = partes[0];
    const mes = meses[parseInt(partes[1], 10) - 1];
    const dia = partes[2];

    const fechaFormateada = `${dia} de ${mes} de ${año}`;

    return fechaFormateada;
};

export const formatDateToDDMMYYYY = (fecha) => {
    if (!fecha) return '';

    const fechaObj = new Date(fecha);

    // Validar que la fecha sea válida
    if (isNaN(fechaObj.getTime())) {
        return '';
    }

    const dia = String(fechaObj.getDate()).padStart(2, '0');
    const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
    const año = fechaObj.getFullYear();

    return `${dia}/${mes}/${año}`;
};

export const formatDateToDDMMYY = (fecha) => {
    if (!fecha) return '';

    const fechaObj = new Date(fecha);

    // Validar que la fecha sea válida
    if (isNaN(fechaObj.getTime())) {
        return '';
    }

    const dia = String(fechaObj.getDate()).padStart(2, '0');
    const mes = String(fechaObj.getMonth() + 1).padStart(2, '0');
    const año = fechaObj.getFullYear().toString().slice(-2);

    return `${dia}/${mes}/${año}`;
};

export const formatSpanishDateTime = (date) => {
    if (!date) return '';

    const dateObj = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObj.getTime())) {
        return '';
    }

    const options = {
        day: '2-digit',
        month: '2-digit',
    };

    const formattedDate = dateObj.toLocaleDateString('es-ES', options).replace(/\b(\d{1})\b/g, '0$1');
    const formattedTime = dateObj.toLocaleTimeString('es-ES');

    return `${formattedDate} ${formattedTime}`;
};

export const esFechaMayorOIgualActual = (fecha) => {
    if (!fecha) return false;

    const fechaActual = new Date();
    const fechaProporcionada = new Date(fecha);

    // Validar que la fecha proporcionada sea válida
    if (isNaN(fechaProporcionada.getTime())) {
        return false;
    }

    return fechaActual >= fechaProporcionada;
};

export const getAgeFromDate = (date) => {
    if (!date) return '';

    const birthDate = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(birthDate.getTime())) {
        return '';
    }

    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    return m < 0 || (m === 0 && today.getDate() < birthDate.getDate()) ? age - 1 : age;
};

export const isBirthdayToday = (fechaNacimientoISO) => {
    if (!fechaNacimientoISO) return false;

    // Convertir la cadena ISO 8601 a un objeto Date
    const fechaNacimiento = new Date(fechaNacimientoISO);

    // Verificación de tipo
    if (!(fechaNacimiento instanceof Date && !isNaN(fechaNacimiento))) {
        throw new TypeError('fechaNacimiento debe ser una cadena de fecha ISO 8601 válida');
    }

    // Obtiene la fecha actual
    const hoy = new Date();

    // Extrae el día, el mes y el año de la fecha de nacimiento
    const diaNacimiento = fechaNacimiento.getDate();
    const mesNacimiento = fechaNacimiento.getMonth();

    // Extrae el día, el mes y el año de hoy
    const diaHoy = hoy.getDate();
    const mesHoy = hoy.getMonth();

    // Verifica si el día, el mes y el año de hoy coinciden con los de la fecha de nacimiento
    return diaHoy === diaNacimiento && mesHoy === mesNacimiento;
};

export const getTimeAgo = (dateString) => {
    if (!dateString) return '';

    const currentDate = new Date();
    const date = new Date(dateString);

    // Validar que la fecha sea válida
    if (isNaN(date.getTime())) {
        return '';
    }

    const diff = currentDate - date;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 31);

    if (seconds < 60) {
        if (seconds === 1) return `Hace ${seconds} segundo`;
        return `Hace ${seconds >= 0 ? seconds : 0} segundos`;
    } else if (minutes < 60) {
        if (minutes === 1) return `Hace ${minutes} minuto`;
        return `Hace ${minutes >= 0 ? minutes : 0} minutos`;
    } else if (hours < 24) {
        if (hours === 1) return `Hace ${hours} hora`;
        return `Hace ${hours >= 0 ? hours : 0} horas`;
    } else if (days < 31) {
        if (days === 1) return `Hace ${days} día`;
        return `Hace ${days >= 0 ? days : 0} días`;
    } else {
        if (months === 1) return `Hace ${months} mes`;
        return `Hace ${months >= 0 ? months : 0} meses`;
    }
};

export const getHourFromDate = (date) => {
    if (!date) return '';

    const dateObj = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObj.getTime())) {
        return '';
    }

    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};

export const getDateFromDate = (date) => {
    if (!date) return '';

    const dateObj = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObj.getTime())) {
        return '';
    }

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}`;
};

export const getDateAndHourFromDate = (date) => {
    if (!date) {
        return { date: '-', hour: '-' };
    }

    const dateObj = new Date(date);

    // Validar que la fecha sea válida
    if (isNaN(dateObj.getTime())) {
        return { date: '-', hour: '-' };
    }

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');

    return {
        date: `${day}/${month}`,
        hour: `${hours}:${minutes}`,
    };
};

export const getUtcDayRangeString = (date) => {
    const start = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));

    const end = new Date(start);
    end.setUTCDate(end.getUTCDate() + 1);

    return {
        startDate: start.toISOString(), // 00:00 UTC de ese día
        endDate: end.toISOString(), // 00:00 UTC del día siguiente
    };
};

export const getRandomDateBetween1MinuteAnd6HoursAgo = () => {
    const now = new Date();
    const sixHoursInMs = 6 * 60 * 60 * 1000;
    const oneMinuteInMs = 1 * 60 * 1000;

    const randomOffset = Math.floor(Math.random() * (sixHoursInMs - oneMinuteInMs) + oneMinuteInMs);

    return new Date(now.getTime() - randomOffset);
};

export const getMarketsUntilDate = (date) => {
    if (!date) return 0;

    const targetDate = new Date(date);
    if (isNaN(targetDate.getTime())) return 0;

    const now = new Date();

    // Si la fecha ya pasó, 0
    if (targetDate <= now) return 0;

    let count = 0;

    // Tomamos la próxima "00:16" después de 'now'
    let nextMarket = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 16, 0, 0);

    // Si ya pasó la 00:16 de hoy, pasamos al siguiente día
    if (nextMarket <= now) {
        nextMarket.setUTCDate(nextMarket.getUTCDate() + 1);
    }

    // Contamos cuántos 00:16 hay hasta la fecha objetivo
    while (nextMarket <= targetDate) {
        count++;
        nextMarket.setUTCDate(nextMarket.getUTCDate() + 1);
    }

    return count;
};

export const formatStartTimeFromBettingSite = (timeString) => {
    if (!timeString) return '';
    try {
        const [datePart, timePart] = timeString.split(' ');
        if (!datePart || !timePart) return timeString;

        const [day, month, year] = datePart.split('/');
        const [hours, minutes] = timePart.split(':');

        if (!day || !month || !year || !hours || !minutes) return timeString;

        const fullYear = `20${year}`;
        const date = new Date(
            `${fullYear}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`
        );

        if (isNaN(date.getTime())) {
            return timeString;
        }

        return getTimeShortWithMinutes(date);
    } catch {
        return timeString;
    }
};
